import httpClient from '%app/js/httpClient';
import { createRequest } from '@paysera/http-client-common';
import { router } from '%app/js/common/services/router';

class CurrentOrderClient {
    getCurrentOrder() {
        const request = createRequest(
            'GET',
            router.generate('paysera_cart.current_order.get_current_order'),
        );

        return httpClient.performRequest(request);
    }
}

export default new CurrentOrderClient();
